<template>
  <div style="max-width: 100%; overflow: hidden;">
    <!-- <div class="q-mb-sm" v-show="$store.state.meStore.me.su">
      <q-btn
        :label="isJoining ? getString(null, 'Confirm', 'Bevestig') : getString(null, 'Edit references together', 'Referenties samen bewerken')"
        color="primary"
        class="capitalize ctrl-button"
        size="sm"
        @click="joinReferences"
        icon="mdi-merge"
      />
    </div> -->
    <!-- Table wrapper -->
    <div class="spare-parts-list">
      <div v-if="commonInReferences" class="spare-parts-list__common-references">
        <div class="spare-parts-list__common-references--spacer"></div>
        <span class="spare-parts-list__common-references--label" :style="`flex: ${references.length}; max-width: ${references.length * 60}px`">
          {{ commonInReferences }}
        </span>
      </div>
      <!-- Headers -->
      <div class="spare-parts-list__headers" :style="`min-width: ${150 + (references.length - hiddenReferences.length - hiddenByJoining.length) * 25}px`">
        <!-- Number -->
        <div class="spare-parts-list__headers--number" style="flex: 0 0 60px !important;">
          <span>No.</span>
        </div>
        <!-- code -->
        <div class="spare-parts-list__headers--code" @click="showItemCode = !showItemCode">
          <span>{{ getString(null, 'Part', 'Onderdeel') }}</span>
        </div>
        <!-- Reference(s) -->
        <div
          v-for="reference in references"
          v-show="!hiddenReferences.includes(reference.id) && (!hiddenByJoining.includes(reference.id) || isJoining)"
          class="spare-parts-list__headers--reference"
          :style="[{ background: hoverReference === reference.id ? '#f1f1f1' : '' }, { opacity: isJoining ? currentReferencesSelection.includes(reference) ? 1 : 0.4 : 1}]"
          :key="reference.id"
          @mouseenter="hoverReference = reference.id"
          @mouseleave="hoverReference = null"
          @click="isJoining ? connectReference(reference) : openReferenceModal()"
        >
          <div class="spare-parts-list__headers--reference-label">
            <div class="spare-parts-list__headers--reference-label-inner">
              {{ reference.label.replace(commonInReferences, '') }}
            </div>
          </div>
        </div>
        <div v-if="!(references.length - hiddenReferences.length - hiddenByJoining.length)" @click="openReferenceModal">Manage references</div>
      </div>

      <!-- data -->
      <div class="spare-parts-list__row"
      :style="`min-width: ${150 + (references.length - hiddenReferences.length - hiddenByJoining.length) * 25}px`"
      :class="{
        'spare-parts-list__row--checked': checkedParts.includes(part.id),
        'spare-parts-list__row--bordered': part.number % 2 === 0,
      }"
      v-for="(part, p) in mappedParts" :key="part.id">
        <!-- Number -->
        <div class="spare-parts-list__row--number" style="flex: 0 0 60px !important;">
          <div>
            <span @click="$emit('updatePartNumber', part)">
              {{ part.number }}
            </span>

            <q-btn
              class="ctrl-btn capitalize"
              @click="removePart(p)"
              round
              flat
              size="sm"
              color="negative"
              icon="delete"
            />
          </div>
        </div>
        <!-- code -->
        <div class="spare-parts-list__row--code">
          <div
            v-show="showItemCode"
            class="spare-parts__table--col"
            style="display: flex; flex-grow: 4;"
          >
            <dot-status :class="{ 'show-status--green': part.item_id !== null }">
              {{
                part.item_id === null
                  ? getString("module.spare-parts.part.status.unmatched")
                  : getString("module.spare-parts.part.status.matched")
              }}
            </dot-status>
            <q-search class="q-pr-md" type="text" v-model="part.item_code" no-icon :placeholder="getString(null, 'Part', 'Onderdeel')">
              <q-autocomplete
                :max-results="25"
                :min-characters="2"
                @search="searchItem"
                @selected="selectItem(part, ...arguments)"
              />
            </q-search>
          </div>
          <div class="spare-parts-list__row--name" v-show="!showItemCode">
            <span v-if="part.item_id">{{ part.name }}</span>
            <q-input
              v-else
              min="1"
              v-model="part.name"
              type="text"
              placeholder="Part name"
            />
          </div>
        </div>
        <!-- Reference(s) -->
        <div
          v-for="(reference, r) in part.references"
          v-if="!hiddenReferences.includes(reference.id) && (!hiddenByJoining.includes(reference.id) || isJoining)"
          class="spare-parts-list__row--reference"
          :style="{ background: hoverReference === reference.id ? '#f1f1f1' : '' }"
          :key="`${p}${r}:${reference.id ? reference.id : 'new'}`"
            @mouseenter="hoverReference = reference.id"
            @mouseleave="hoverReference = null"
        >
          <input
            :id="`quantity:${p}:${r}`"
            type="number"
            min="0"
            step="1"
            @keydown.shift.a.prevent="assignToAll(part, reference.quantity)"
            @keydown.shift.c.prevent="assignToAll(part, 0)"
            @keydown.left.prevent="navigateToRowColumn(p, r - 1)"
            @keydown.right.prevent="navigateToRowColumn(p, r + 1)"
            @keydown.up.prevent="navigateToRowColumn(p - 1, r)"
            @keydown.down.prevent="navigateToRowColumn(p + 1, r)"
            @focus="(e) => e.target.select()"
            class="spare-parts-list__qty-input"
            :class="{ 'spare-parts-list__qty-input--empty': reference.quantity == 0 }"
            v-model="reference.quantity"
          />
        </div>

      </div>
    </div>

    <!-- References modal -->
    <q-modal v-model="referencesModal">
      <q-modal-layout>
        <q-toolbar slot="header" color="tertiary">
          <q-toolbar-title>
            {{ getString(null, 'Manage references', 'Referenties beheren') }}
          </q-toolbar-title>
          <q-btn flat round dense v-close-overlay icon="close" />
        </q-toolbar>

        <div class="row" v-if="$store.state.meStore.me.su">
          <q-input class="col col-10" placeholder="Sorting" v-model="sortingString" />
          <q-btn
            class="ctrl-btn capitalize q-ml-md"
            :label="getString(null, 'Sort', 'Sorteren')"
            @click="sortAndFilterReferences()"
            color="primary"
            icon-right="sort" />
        </div>

        <draggable
          class="full-width"
          v-model="modalReferences"
          handle=".references__row--handle"
          @start="drag = true"
          @end="drag = false"
        >
          <transition-group type="transition" name="list">
            <div
              class="references__row q-pa-sm q-mb-sm q-mt-sm"
              :class="{'references__row--hidden': hiddenReferences.includes(reference.id) }"
              v-for="(reference, r) in modalReferences"
              :key="`${reference.edit && 'e-'}${r}:${reference.id ? reference.id : 'new'}`"
            >
              <div class="references__row--label row">
                <div class="col-8">
                  <q-search class="full-width" type="text" v-model="reference.label" no-icon :placeholder="'Reference'">
                    <q-autocomplete
                      :max-results="25"
                      :min-characters="2"
                      @search="searchReference"
                      @selected="selectReference(reference, ...arguments)"
                    />
                  </q-search>
                </div>
                <div class="references__row--actions">
                  <q-btn
                    class="ctrl-btn capitalize"
                    color="grey-5"
                    flat
                    round
                    dense
                    @click="toggleReferenceVisibility(reference)"
                    icon="remove_red_eye"
                  />
                  <q-btn
                    class="ctrl-btn capitalize"
                    color="primary"
                    flat
                    round
                    dense
                    @click="addReference(reference, r)"
                    icon="content_copy"
                  />
                  <q-btn
                    class="ctrl-btn capitalize"
                    color="negative"
                    flat
                    round
                    dense
                    @click="removeReference(reference)"
                    icon="delete"
                  />
                  <div class="references__row--handle">
                    <i aria-hidden="true" class="q-icon material-icons">menu</i>
                  </div>
                </div>
              </div>
            </div>
          </transition-group>
        </draggable>

        <div class="q-mt-md">
          <q-btn
            class="ctrl-btn capitalize"
            :label="getString(null, 'Add reference', 'Referentie toevoegen')"
            @click="addReference()"
            color="primary"
            icon-right="add"
          />
          <q-btn
            class="ctrl-btn capitalize q-ml-md"
            :label="getString(null, 'Save', 'Opslaan')"
            @click="saveReferences()"
            color="positive"
            icon-right="save"
          />
        </div>

      </q-modal-layout>
    </q-modal>
  </div>
</template>

<script>
import getString from '@/helpers/GetStrings';
import DotStatus from '@/components/status/DotStatus.vue';
import draggable from 'vuedraggable';
import _debounce from 'lodash.debounce';

export default {
  components: {
    DotStatus,
    draggable,
  },
  props: {
    parts: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      hoverReference: null,
      sortingString: '',
      displayCopy: null,
      drag: false,
      showItemCode: true,
      references: [],
      mappedParts: [],
      hiddenReferences: [],
      toRemoveReferences: [],
      activeReference: null,
      newReference: '',
      referencesModal: false,
      modalReferences: [],
      checkedParts: [],
      newReference: {
        label: '',
        id: null,
      },
      isJoining: false,
      currentReferencesSelection: [],
      hiddenByJoining: [],
    };
  },

  methods: {
    getString,

    // This allows references to be connected so that they share the same quantities for each part
    joinReferences() {
      if (this.isJoining) {
        this.confirmJoining();
      }
      this.isJoining = !this.isJoining;
    },

    connectReference(reference) {
      if (this.currentReferencesSelection.includes(reference)) {
        this.currentReferencesSelection = this.currentReferencesSelection.filter(ref => ref !== reference);
      } else {
        this.currentReferencesSelection.push(reference);
      }
    },

    confirmJoining() {
      // For all references in the current selection, add a property 'joined'
      this.currentReferencesSelection = [];
    },

    /**
     * Search for items
     */
     async searchItem(terms, done, addNew = true) {
      try {
        // Request items based on terms given
        const results = await this.axios.get(`item?code=${terms.replaceAll(' ', '').toLowerCase()}`);

        // Map only the item names/labels... to the suggested array
        const suggested = results.data.items.map(item => ({ label: item.code, id: item.id }));

        // Suggested items found, return suggestions.
        if (suggested.length) {
          done(suggested);
        }

        // Since an error is thrown when no items are found in autocomplete -> promt new suggestion here.
      } catch (error) {
        if (addNew) {
          done([{ label: `(Add) ${terms}`, value: terms, new: true }]);
        } else {
          done([]);
        }
      }
    },

    /**
     * Search for references
     */
    async searchReference(terms, done, addNew = true) {
      try {
        // Request items based on terms given
        const results = await this.axios.get(
          `spareparts/references?reference=${terms.toLowerCase()}`,
        );

        // Map only the item names/labels... to the suggested array
        const suggested = results.data.spare_part_references.map(item => ({
          label: item.reference,
          id: item.id,
        }));

        // Suggested items found, return suggestions.
        if (suggested.length) {
          done(suggested);
        }

        // Since an error is thrown when no items are found in autocomplete -> promt new suggestion here.
      } catch (error) {
        if (addNew) {
          done([{ label: `(Add) ${terms}`, value: terms, new: true }]);
        } else {
          done([]);
        }
      }
    },

    selectReference(item, found, keyboard) {
      if (found.new) {
        found.label = found.label.replace('(Add) ', '');
        found.id = null;
      }

      // Prevent adding on keyboard arrow down
      if (keyboard) return;

      item.label = found.label;
      item.id = found.id;
    },

    selectItem(item, found, keyboard) {
      if (found.new) {
        found.label = found.label.replace('(Add) ', '');
        found.id = null;
      }
      // Prevent adding on keyboard arrow down
      if (keyboard) return;
      item.item_code = found.label;
      item.item_id = found.id;
    },

    /**
     * Open a dialog to allow the order of the references to be changed.
     */
    openReferenceModal() {
      this.modalReferences = this.copyOf(this.references);
      this.referencesModal = true;
    },
    /**
     * Adds a new reference column
     */
    addReference(reference = { label: '', id: null }, index = null) {
      let referenceLabel = '';
      // Check if the reference is a copy and contains a digit in parentheses
      const regex = /\(([0-9]+)\)/;
      const matches = reference.label.match(regex);

      if (matches) {
        const num = Number(matches[1]);
        referenceLabel = `${reference.label.substring(0, matches.index)}(${num + 1})`;
      } else if (reference.label) {
        referenceLabel = `${reference.label}(1)`;
      }

      const randomId = Math.random()
        .toString(36)
        .substring(7);

      this.newReference = {
        label: referenceLabel,
        id: `new-${randomId}`,
        quantity: reference?.quantity || 0
      };
      if (index) {
        this.modalReferences.splice(index + 1, 0, this.newReference);
      } else {
        this.modalReferences.push(this.newReference);
      }
    },

    /**
     * Saves the changes made in the references modal
     */
    saveReferences() {
      // add sort_id to the references
      this.modalReferences.forEach((ref, i) => {
        ref.sort_id = i + 1;
      });
      this.references = this.copyOf(this.modalReferences);
      this.mapReferencesToParts();
      this.referencesModal = false;
      this.toRemoveReferences = [];

      this.updateParts();
    },

    /**
     * Map the references to the parts in the correct order.
     */
    mapReferencesToParts() {
      const referenceLabels = this.modalReferences.map(reference => reference.label);
      const existingReferences = this.mappedParts[0].references.map(reference => reference.label);
      const removeReferences = this.toRemoveReferences.map(reference => reference.label);

      // Get the sort_id of the references and key it to the label
      const sortIds = {};
      this.modalReferences.forEach((ref, i) => {
        sortIds[ref.label] = i + 1;
      });

      // Get the new references
      const newReferences = this.modalReferences
        .filter(x => !existingReferences.includes(x.label))
        .map((ref) => {
          return {
            label: ref.label,
            id: ref.id,
            quantity: ref.quantity || 0,
            sort_id: ref.sort_id || null,
          };
        });

      // The order of the references in the parts array must match the order of the references in the references array.
      this.mappedParts.forEach(part => {
        // Add new references to the part
        part.references = part.references.concat(this.copyOf(newReferences));

        // Add sort_id to the references
        part.references.forEach((ref) => {
          ref.sort_id = sortIds[ref.label];
        });

        // Remove references found in the toRemoveReferences array
        part.references = part.references.filter((ref) => {
          return !removeReferences.includes(ref.label) && referenceLabels.includes(ref.label);
        });

        part.references.sort((a, b) => {
          return referenceLabels.indexOf(a.label) - referenceLabels.indexOf(b.label);
        });
      });
    },

    sortAndFilterReferences() {
      this.hiddenReferences = [];
      // Split the sorting string into an array and use the first 5 characters of each string to sort the references, filter duplicates
      const compare = this.sortingString.split(',').map(x => x.trim());

      // remove all quotes from the compare array
      compare.forEach((x, i) => {
        compare[i] = x.replace(/['"]+/g, '');
      });

      // Add any any references that are not in the compare array to the hiddenReferences array
      this.modalReferences.forEach(ref => {
        if (!compare.includes(ref.label.replace(/['"]+/g, ''))) {
          this.hiddenReferences.push(ref.id);
        }
      });

      this.modalReferences.sort((a, b) => {
        // sort the array based on partial matches of the sorting string
        return compare.indexOf(a.label) - compare.indexOf(b.label);
      });

      // add sort_id to the references
      this.modalReferences.forEach((ref, i) => {
        ref.sort_id = i;
      });
    },

    copyOf(object) {
      return JSON.parse(JSON.stringify(object));
    },

    /**
     * Removes a part from the list at the given index
     */
    removePart(index) {

      this.$q
        .dialog({
          title: this.getString(
            null,
            'Confirm removal of part',
            'Bevestig de verwijdering van het onderdeel',
          ),
          message: 'This will remove the part from the list',
          ok: 'OK',
          cancel: 'Cancel',
          persistent: true,
        })
        .then(() => {
          this.mappedParts.splice(index, 1);
        });
    },

    toggleReferenceVisibility(reference) {
      if (this.hiddenReferences.includes(reference.id)) {
        this.hiddenReferences.splice(this.hiddenReferences.indexOf(reference.id), 1);
      } else {
        this.hiddenReferences.push(reference.id);
      }
    },

    /**
     * By using the arrow keys, the cursor position can
     * move to inputs of different references or parts.
     */
    navigateToRowColumn(row, column) {
      if (row < 0 || column < 0) return;
      if (row > this.mappedParts.length || column > this.references.length) return;

      // Get the input element `quantity:${row}:${column}`
      const input = document.getElementById(`quantity:${row}:${column}`);

      // If the input element exists, focus it and select it
      if (input) {
        input.focus();
      }
    },

    removeReference(reference) {
      this.$q
        .dialog({
          title: this.getString(
            null,
            'Confirm removal of reference',
            'Confirm removal of reference',
          ),
          message: 'This will remove this reference and its link to all parts. Are you sure?',
          ok: 'OK',
          cancel: 'Cancel',
          persistent: true,
        })
        .then(() => {
          this.modalReferences = this.modalReferences.filter(x => x.label!== reference.label);
          this.toRemoveReferences.push(reference);
        });
    },

    copyReferece(reference) {
      // Copy the reference and add it to the references array
      const newReference = {
        id: 'new',
        label: `${reference.label}(2)`,
        quantity: reference.quantity,
      };

      this.references.push({
        id: newReference.id,
        label: newReference.label,
      });

      // loop through the mapped parts and add the new reference
      this.mappedParts.forEach(part => {
        // Find the reference that matches
        const found = part.references.find(ref => ref.id === reference.id);
        if (found) {
          part.references.push({
            id: newReference.id,
            label: newReference.label,
            quantity: found.quantity,
          });
        }
      });
    },

    copyPart(partId) {
      // Find the index of the part in the mapped parts array
      const partIndex = this.mappedParts.findIndex(part => part.id === partId);
      const part = this.copyOf(this.mappedParts[partIndex]);

      // Set a new id
      part.id = null;

      // Splice a copy of the part to the mapped parts array at the given index
      this.mappedParts.splice(partIndex + 1, 0, part);
    },

    assignToAll(part, quantity) {
      // if quantity is not a number, return
      if (isNaN(quantity)) return;
      part.references.forEach(ref => {
        // Exclude hidden references
        if (!this.hiddenReferences.includes(ref.id)) {
          ref.quantity = quantity;
        }
      });
    },

    /**
     * Map the references from the parts list once
     *
     */
    getAllReferences() {
      let references = [];

      // For each part, add the references
      this.parts.forEach(part => {
        // add all these references to the references array if they are not already in there
        references = references.concat(part.references);
      });

      // Filter out duplicates
      this.references = [...new Map(references.map(item => [item.label, item])).values()];

      // Map the references
      this.references = this.mapReferences(this.references);
    },

    mapReferences(references) {
      return references.map(reference => {
        return {
          label: reference.label,
          id: reference.id,
          visible: true,
        };
      });
    },

    /**
     * Map parts to include all the references
     */
    mapParts() {
      let mappedParts = this.parts;
      const referenceLabels = this.references.map(reference => reference.label);

      mappedParts.forEach(part => {
        part.checked = false;

        // Format the item codes to make them more legible
        if (part.item_code) {
          // split the part code into groups of 3 characters
          const groups = part.item_code.match(/.{1,3}/g);

          part.item_code = groups.join(' ');
        }

        // Loop through all the references and if the part does not have the reference, add it
        this.references.forEach(reference => {
          if (!part.references.find(ref => ref.label === reference.label)) {
            part.references.push({
              label: reference.label,
              id: reference.id,
              quantity: 0,
              sort_id: reference.sort_id || null,
            });
          }
        });

        part.references.sort((a, b) => {
          return referenceLabels.indexOf(a.label) - referenceLabels.indexOf(b.label);
        });
      });

      this.mappedParts = mappedParts;
    },

    commonPrefix(words) {
      // check border cases size 1 array and empty first word)
      if (!words[0] || words.length ==  1) return words[0] || "";
      let i = 0;
      // while all words have the same character at position i, increment i
      while(words[0][i] && words.every(w => w[i] === words[0][i]))
        i++;

      // Only show a prefix if it is at least 3 characters long
      if (i < 3) return '';

      // prefix is the substring from the beginning to the last successfully checked i
      return words[0].substr(0, i);
    },

    updateParts() {
      const parts = this.copyOf(this.mappedParts);

      parts.forEach((part) => {
        // Replace all references where the quantity is 0
        part.references = part.references.filter(ref => Number(ref.quantity) > 0);
        if (part.item_code) {
          // This just removes the formatting
          part.item_code = part.item_code.replaceAll(' ', '');
        }
      });
      this.$emit('updated', parts);
    },
  },

  computed: {
    commonInReferences() {
      if (this.references.length > 1) {
        // Find the common prefix in the strings in the references array
        return this.commonPrefix(this.references.map(reference => reference.label));
      }
      return '';
    },
  },

  mounted() {
    this.getAllReferences();
    this.mapParts();
  },

  watch: {
    mappedParts: {
      deep: true,
      handler: _debounce(function () {
        this.updateParts();
      }, 300),
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';

.spare-parts-list
    border 1px solid #ccc;
    overflow-x scroll
    &__common-references
      display flex
      flex-direction row
      &--spacer
        width 210px
      &--label
        display flex
        justify-content center
        font-size 12px
        padding-top 5px
    &__qty-input
        all: unset;
        width: 15px;
        &:not(&--empty)
            font-weight bolder
        &--empty
            color #eee;
    &__headers
        display: flex;
        border-bottom 1px solid #ccc;
        position sticky;
        top: -35px;
        background #fff;
        z-index 1000
        &--code, &--number
            display flex
            flex-direction column
            justify-content end
          span
            padding 10px
        &--number
          flex 1
        &--reference
            writing-mode: vertical-rl;
            text-orientation: mixed;
            transform: rotate(180deg);
            cursor pointer
            flex-direction: row;
            justify-content: space-between;
            &:hover:not(.spare-parts-list__headers--reference-active)
                background-color $ctrl-grey-lighten-1
        &--reference-active
          background-color $ctrl-row-select-bg
          color $ctrl-row-select-text
        &--reference-label
          padding 10px 0 !important
          display flex
          flex-direction column
          justify-content center
          height 100%
          span
            display inline-block
            padding 0
        &--reference-label-inner
          display flex
          flex-direction row
          justify-content space-between
          > div
            margin-top 5px
    &__row
        display: flex;
        height 42px
        ::before {
            border-style: none;
        }
        &--bordered
          background-color: $ctrl-table-striped-dark;
        &--number
          flex 1
          display flex
          flex-direction column
          justify-content center
          span
            padding 10px 0 10px 10px
          > div > .ctrl-btn
              opacity 0.2
              filter: grayscale(1);
              transition 0.3s all ease-in-out
              &:hover
                opacity 1
                filter: grayscale(0);
        &--reference
            justify-content: center;
        &--name
          display: flex;
          flex-direction: column;
          justify-content: center;
          white-space nowrap
          height 38px
          max-width 150px
          span
            overflow: hidden;
            text-overflow: ellipsis;
    &__headers, &__row
        min-width max-content
        &--remarks
            flex 3;
            display flex
            span
              padding 10px
        &--number
            flex 1;
        &--code
            flex 0 0 150px;
            display flex
            cursor pointer
        &--reference
            flex: 1 0 18px
            display flex;
            text-align center;
            max-width 60px;

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* this is for Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.references
  &__row
    display flex
    justify-content space-between
    background $ctrl-grey-lighten-1
    &--hidden
      opacity 0.4
    &--handle
        cursor grab
        display flex
        flex-direction column
        justify-content center
        &:active
            cursor grabbing
    &--label
      display flex
      flex 1
    &--actions
      display flex
      justify-content end
      flex 1

.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}
</style>
